<template>
  <div class="pageContol templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">设备管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考场管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">设备列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" :highlight-current-row="true" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="设备类型" align="left" show-overflow-tooltip prop="deviceType" minWidth="100">
              <template slot-scope="scope">
                {{ scope.row.deviceType ? $setDictionary("PA_DEVICE_TYPE", scope.row.deviceType) : "" }}
              </template>
            </el-table-column>
            <el-table-column label="设备标识" align="left" show-overflow-tooltip prop="deviceCode" minWidth="400" />
            <el-table-column label="设备IP" align="left" prop="ipAddress" width="150">
              <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.ipAddress"
                    placeholder="请输入"
                    @blur="algorithm(scope.$index, scope.row)"
                  ></el-input>
                  <span>{{ scope.row.retainedAmount }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px" >
              <template slot-scope="scope">
                <el-button type="text" style="padding: 0px 5px" size="mini" @click="to_module(scope.row)">查看</el-button>
                <el-button type="text" style="padding: 0px 5px" size="mini" @click="deleteDevice(scope.row)">删除</el-button>
              </template>
            </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "practicalAssessmentSystem_systemManage_seeDeviceList",
  name: "systemManage_room",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 上个页面传过来的数据
      lastPageData: {
        roomId: "", // 考场id
      },
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    this.lastPageData.roomId = this.$route.query?.roomId ?? ""; // 考场id
  },
  methods: {
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        roomId: this.$route.query.roomId
      };
      this.doFetch({
        url: "/biz/v2/room/device/list",
        params,
        pageNum,
      }, true, 10);
    },
    // 更改ip地址
    algorithm(index, row) {
      if(row.ipAddress){
        this.$post("/biz/v2/room/device/ip/upd", { 
          deviceId: row.deviceId,
          ipAddress: row.ipAddress 
        },3000,true,10).then(res => {
          this.getData(this.pageNum)
        });
      }
    },
    // 查看设备下模块列表
    to_module(row) {
      this.$router.push({
        path: "/practicalAssessmentSystem/systemManage/room_device_module",
        query: {
          roomId: row.roomId,
          codeId: row.adminId
        }
      })
    },
    //删除设备
    deleteDevice(row) {
      this.$confirm('您确定删除当前设备绑定关系吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/biz/v2/room/device/delete", {
          deviceId: row.deviceId
        }, 3000, true, 10).then((res) => {
          this.getData();
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped></style>
